import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  InputLabel,
  CardContent,
  Card,
  CardActions,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useStyles from "../../../themes/style.js";
import PageTitle from "../../../components/PageTitle/PageTitle.js";
import { Autocomplete } from "@material-ui/lab";
import axios from "axios";
import { useNotification } from "../../../hooks/useNotification.js";
import moment from "moment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import NoDataFound from "../../../components/NoDataFound/index.js";

function AddProjectDetails() {
  const classes = useStyles();
  const handleNotificationCall = useNotification();

  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [userName, setUserName] = useState([]);
  const [clientName, setClientsName] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetchProjectData();
  }, []);

  async function fetchProjectData() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}employee/viewAllProjects`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        const data = response.data.data;
        setProjects(data);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log("Error Fetch Profile Data", error);
    }
  }

  useEffect(() => {
    fetchUserName();
    getClientName();
  }, []);

  const fetchUserName = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setUserName(userList);
        console.log(response.data.data);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const getClientName = async () => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/getAllCCList`,
      data: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setClientsName(response.data.data);
        }
      })

      .catch(function (error) {
        console.log(error);
      });
  };

  const handleFeedbackModalOpen = () => {
    setFeedbackModalOpen(true);
  };

  const validationSchema = Yup.object().shape({
    projectName: Yup.string().required("Project Name is required"),
    userId: Yup.string().required("Please Select User "),
    hiringManagerId: Yup.string().required("Please Select Hiring Manager"),
    projectDetails: Yup.string().required("Project Details is required"),
  });

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
  };

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  async function handleAdd(values) {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/addProjects`,
        {
          projectName: values.projectName,
          userId: values.userId,
          hmId: values.hiringManagerId,
          projectDetails: values.projectDetails,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleFeedbackModalClose();
        reset();
        handleNotificationCall("success", response.data.message);
        fetchProjectData();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  }

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <Grid container direction="row" spacing={2} className={classes.heading}>
          <Grid item xs={9} sm={7} md={8} lg={6}>
            <PageTitle title="Add Projects to Employee" />
          </Grid>
          <Grid
            item
            xs={3}
            sm={5}
            md={4}
            lg={6}
            className={classes.drawerClose}
          >
            <div className={classes.lgButton}>
              <Button
                variant="contained"
                size="small"
                color="primary"
                startIcon={<AddCircleIcon />}
                className={classes.addUser}
                onClick={handleFeedbackModalOpen}
              >
                Add Project
              </Button>
            </div>

            <div className={classes.smButton}>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddCircleIcon />}
                className={classes.addUser}
                color="primary"
                onClick={handleFeedbackModalOpen}
              >
                Add
              </Button>
            </div>
          </Grid>
        </Grid>
        {projects.length === 0 && <NoDataFound height="80vh" message="No Data Found"/>}
        <Grid container spacing={2}>
          {projects.map((project) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={project.id}>
              <Card className={classes.root} variant="outlined">
                <CardContent>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h3>
                      {project.hiringManager.recruiter === null
                        ? project.hiringManager.employee?.firstName +
                          " " +
                          project.hiringManager.employee?.lastName
                        : project.hiringManager.recruiter?.firstName +
                          " " +
                          project.hiringManager.recruiter?.lastName}
                    </h3>
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        background: "#ccc",
                      }}
                    ></div>
                  </div>

                  <h2 color="textPrimary" style={{ marginTop: 0,fontSize: "14px" }}>
                    {project.projectName}
                  </h2>
                  <Typography
                    variant="body2"
                    component="p"
                    style={{
                      minHeight: "150px",
                      overflow: "scroll",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 6,
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {project.projectDetails}
                  </Typography>
                </CardContent>
                <CardActions
                  style={{
                    padding: "0px 16px 16px",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  {/* <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    handleFeedbackModalOpen();
                  }}
                >
                  Read More
                </Link> */}
                  <div style={{ color: "#555" }}>
                    {moment(project.createdAt).format("MMM Do YYYY")}
                  </div>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Dialog
          open={feedbackModalOpen}
          fullWidth
          maxWidth="xs"
          onClose={handleFeedbackModalClose}
          aria-labelledby="form-dialog-title"
        >
          <form onSubmit={handleSubmit(handleAdd)}>
            <DialogContent>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <InputLabel shrink htmlFor="userId">User</InputLabel>
                  <FormControl className={classes.margin}>
                    <Controller
                      name="userId"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          className="filterFullWidth mt-2"
                          options={userName}
                          getOptionLabel={(option) => `${option.fullName}`}
                          onChange={(event, value) => {
                            setValue("userId", value ? value.id : null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label=""
                              className={classes.autoCompleteSizeAdjust}
                              InputLabelProps={{ shrink: true }}
                              type="text"
                            />
                          )}
                        />
                      )}
                    />
                    <Typography variant="inherit" color="error">
                      {errors.userId?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <InputLabel shrink htmlFor="projectName">
                    Project
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      placeholder="Enter Subject"
                      name="projectName"
                      {...register("projectName")}
                      error={errors.projectName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.projectName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <InputLabel shrink htmlFor="hiringManagerId">Hiring Manager</InputLabel>
                  <FormControl className={classes.margin}>
                    <Controller
                      name="hiringManagerId"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          className={`${classes.autoCompleteSizeAdjust} filterFullWidth mt-2`}
                          options={clientName}
                          getOptionLabel={(option) =>
                            `${option.firstName} ${option.lastName}`
                          }
                          onChange={(event, value) =>
                            setValue(
                              "hiringManagerId",
                              value ? value.user.id : null,
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select Hiring Manager"
                              label=""
                              className={classes.autoCompleteSizeAdjust}
                              InputLabelProps={{ shrink: true }}
                              type="text"
                            />
                          )}
                        />
                      )}
                    />
                    <Typography variant="inherit" color="error">
                      {errors.hiringManagerId?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <InputLabel shrink htmlFor="projectDetails">
                    Project Details
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      multiline
                      minRows={8}
                      size="small"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      placeholder="Enter your Feedback Message..."
                      name="projectDetails"
                      {...register("projectDetails")}
                      error={errors.projectDetails ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.projectDetails?.message}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ padding: "12px 24px" }}>
              <Button
                onClick={handleFeedbackModalClose}
                variant="contained"
                color="secondary"
                size="small"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                type="submit"
              >
                Send
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    </>
  );
}

export default AddProjectDetails;
